import { DevTools, Tolgee, FormatSimple } from "@tolgee/web";
import { TOLGEE_REMOTE_ENABLED, tolgeeApiKey, tolgeeApiUrl } from "@/lib/tolgee/config";

export const ALL_LANGUAGES = ["ru", "en", "kz"];
export const DEFAULT_LANGUAGE = "ru";

/**
 * Creates base Tolgee instance with common configuration
 * - DevTools enabled only in development
 * - API credentials from environment variables
 */
export function TolgeeBase() {
  const tolgee = Tolgee().use(FormatSimple());

  // Enable DevTools only in development
  if (TOLGEE_REMOTE_ENABLED && process.env.NODE_ENV === "development") {
    tolgee.use(DevTools());
  }

  return tolgee.updateDefaults({
    apiKey: tolgeeApiKey,
    apiUrl: tolgeeApiUrl,
  });
}
